import axios from "axios";
import { expressURL } from "../lib/Constants";
import { getAccessToken } from "../lib/Functions";

// restituisce le Q&A di un libro da AIpen (se ci sono)
export const getQAInBook = async (aipenID: number): Promise<any> => {
    const token = await getAccessToken();
    const config: Object = {
        method: "get",
        url: `${expressURL}/api/aipen/qa/${aipenID}`,
        headers: {
            "Authorization": `Bearer ${token}`,
        },
    };
    return await axios(config);
};

export const askQuestionJob = async (payload: any, aipenID: number): Promise<any> => {
    const token = await getAccessToken();
    const config: Object = {
        method: "POST",
        url: `${expressURL}/api/aipen/question/${aipenID}`,
        data: JSON.stringify(payload),
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
    };

    return await axios(config);
};

export const checkAipenRole = async (): Promise<any> => {
    const token = await getAccessToken();
    const config: Object = {
        method: "GET",
        url: `${expressURL}/api/aipen/check-role`,
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
    };

    return await axios(config);
};

export const checkUser = async (): Promise<any> => {
    const token = await getAccessToken();
    const config: Object = {
        method: "POST",
        url: `${expressURL}/api/aipen/check-user`,
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
    };

    return await axios(config);
};

export const sendFeedback = async (payload: any): Promise<any> => {
    const token = await getAccessToken();
    const config: Object = {
        method: "POST",
        url: `${expressURL}/api/aipen/feedback`,
        data: JSON.stringify(payload),
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
    };

    return await axios(config);
};

export const getFeedback = async (id: number): Promise<any> => {
    const token = await getAccessToken();
    const config: Object = {
        method: "GET",
        url: `${expressURL}/api/aipen/feedback/${id}`,
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
    };

    return await axios(config);
};